export const getGatewayDomain = () => process.env.VITE_DEVICE_GATWAY_URL || 'device-gateway.stage.wemolo.com'

// A local gateway (docker compose) is plain HTTP; stage/prod are TLS-terminated. Detect by host so
// local dev works without hand-editing ws→wss / http→https, while stage/prod stay secure.
const isLocalGateway = (domain: string) => /^(localhost|127\.|0\.0\.0\.0|host\.docker\.internal)/.test(domain)

export const getGatewayWsUrl = (path: string) => {
    const domain = getGatewayDomain()
    return `${isLocalGateway(domain) ? 'ws' : 'wss'}://${domain}${path}`
}

export const getGatewayHttpUrl = (path: string) => {
    const domain = getGatewayDomain()
    return `${isLocalGateway(domain) ? 'http' : 'https'}://${domain}${path}`
}
